import { RadioGroup } from '@pwc/pwc-deals-ui';
import { ChangeEvent } from 'react';
import styles from './RadioGroupWithSubtitle.module.scss';

interface FieldInterface {
  name: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

interface OptionInterface {
  name?: string;
  value: string;
  key?: string;
  label: string;
}

type Props = {
  label: string;
  subTitle?: string;
  field: FieldInterface;
  options: OptionInterface[];
};

export const RadioGroupWithSubtitle = ({
  label,
  subTitle,
  field,
  options,
}: Props) => (
  <div>
    <div className={styles.title}>{label}</div>
    <div className={styles.subTitle}>{subTitle}</div>

    <RadioGroup
      field={field}
      options={options}
      direction="column"
      className={styles.bulletPointTopAligned}
    />
  </div>
);
